import * as React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaFacebook, FaInstagram } from 'react-icons/fa'
import { Link } from 'gatsby'
import ChatButton from '../../buttons/chat-button/ChatButton'
import ContentContainer from '../../content/ContentContainer/ContentContainer'
import ContentCover from '../../content/ContentCover/ContentCover'
import {
  chatButton,
  footerBottom,
  footerTop,
  iconRow,
  mainFooter,
  menuContainer,
  menuHeader,
  phoneLink,
  questionItems,
  secondCol,
} from './footer.module.scss'

export function Footer() {
  return (
    <ContentCover>
      <ContentContainer>
        <footer className={mainFooter}>
          <div className={footerTop}></div>
          <div className={footerBottom}>
            <Row>
              <Col className={menuContainer} md='6' lg='3'>
                <h3 className={menuHeader}>Important Links</h3>
                <Link to='/30-day-money-back-guarantee'>
                  30 Day Money Back Guarantee
                </Link>
                <Link to='/price-match'>Price Match</Link>
                <Link to='/warranty'>Warranty</Link>
                <Link to='/shipping-disclaimer'>Shipping Disclaimer</Link>
                <Link to='/free-shipping'>Free Shipping</Link>
              </Col>
              <Col className={menuContainer} md='6' lg='3'>
                <div className={secondCol}>
                  <Link to='/privacy-policy'>Privacy Policy</Link>
                  <Link to='/terms-of-service'>Terms of Service</Link>
                  <Link to='/return-policy'>Returns</Link>
                  <Link to='/prop65'>Prop 65</Link>
                </div>
              </Col>
              <Col className={menuContainer} md='6' lg='3'>
                <h3 className={menuHeader}>About Us</h3>
                <Link to="/about-us">About Us</Link>
                <Link to="/blog">Blog</Link>
                <Link to="/contact-us">Contact Us</Link>
              </Col>
              <Col className={menuContainer} md='6' lg='3'>
                <h3 className={menuHeader}>Questions?</h3>
                <p className={questionItems}>
                  Call Toll Free at:{' '}
                  <a className={phoneLink} href='tel:18009361287'>
                    1-800-936-1287
                  </a>
                </p>
                <p className={questionItems}>
                  Email:{' '}
                  <a
                    className={phoneLink}
                    href='mailto:info@rubberflooring4u.com'
                  >
                    {' '}
                    info@rubberflooring4u.com{' '}
                  </a>
                </p>
                <ChatButton customClass={chatButton}>Chat With Us</ChatButton>
                <Row className={iconRow}>
                  <Link
                    href="https://www.facebook.com/Rubberflooring4u"
                    className="w-auto"
                    target="_blank"
                    aria-label="facebook"
                  >
                    <FaFacebook></FaFacebook>
                  </Link>
                  <Link
                    href="https://www.instagram.com/rubberflooring4u/"
                    className="w-auto"
                    target="_blank"
                    aria-label="instagram"
                  >
                    <FaInstagram></FaInstagram>
                  </Link>
                </Row>
              </Col>
            </Row>
          </div>
        </footer>
      </ContentContainer>
    </ContentCover>
  )
}
